export default {
  borderRadius: 4
};
